import './ThankYouPage.scss';
import {FC, useMemo} from 'react';
import Helmet from "react-helmet";
import React from 'react';
import {CMSConfiguration, getNavPathFromType, JCMSCTA} from "@jnext/commons";
import {CoreUserContext} from "../../../type/coreUserContext";
import {GenericPage} from "../GenericPage";
import {mzUseNavigate} from "../../../utils";

export interface ThankYouPageProps {
    context: CoreUserContext
    title?: string,
    cmsConfig?: CMSConfiguration
}
export const ThankYouPage: FC<ThankYouPageProps> = (props) => {
    const  navigate = mzUseNavigate();

    const buttonCTA = useMemo(()=> props.cmsConfig?.section?.cta, [props.cmsConfig?.section?.cta]);

    const cmsConfig = { ...props.cmsConfig };

    const onClick = (scope: string) => {
        if (scope.toLowerCase() !== 'submit') {
            return navigate(getNavPathFromType(scope))
        }
        return history.back();
    }
    return (
        <GenericPage
            cmsConfig={props.cmsConfig}
        >
            {
                cmsConfig?.page?.options?.metaTags?.title
                    ?
                    <Helmet>
                        <title>{cmsConfig?.page?.options?.metaTags?.title}</title>
                        {cmsConfig?.page?.options?.metaTags?.description && <meta name="description" content={cmsConfig?.page?.options?.metaTags?.description} />}
                    </Helmet>
                    :
                    <Helmet>
                        <title></title>
                        <meta name="description" content={''} />
                    </Helmet>
            }

            <div className='thankyou-page-cta-wrapper'>
                {
                    buttonCTA && buttonCTA.map(cta => {
                        return (<JCMSCTA {...cta} action={() => cta?.scope && onClick(cta.scope)}/>)
                    })
                }
            </div>

        </GenericPage>
    )
}
